import { request } from '@umijs/max';

type RequestExtra = Record<string, unknown>;

interface IntroductionListParams {
  page?: number;
  limit?: number;
  sorter?: string;
  version?: API.Flag01;
  status?: API.Flag01;
}

interface IntroductionListResult {
  data: {
    list: API.IntroductionInfo[];
    total: number;
  };
  success?: boolean;
}

export async function queryIntroductionList(
  params?: IntroductionListParams,
  options?: RequestExtra,
) {
  return request<IntroductionListResult>('/api/v1/introduction', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function queryIntroductionById(
  id: number,
  options?: RequestExtra,
) {
  return request<{ data: API.IntroductionInfo }>('/api/v1/introduction/' + id, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function addIntroduction(
  data: API.IntroductionInfoVO,
  options?: RequestExtra,
) {
  return request('/api/v1/introduction', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

export async function updateIntroduction(
  id: number,
  body: API.IntroductionUpdateVO,
  options?: RequestExtra,
) {
  return request(`/api/v1/introduction/${id}`, {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

export async function removeIntroduction(id: number, options?: RequestExtra) {
  return request(`/api/v1/introduction/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}
